import QuickCommentInput from '@src/basic-components/CommentInput/QuickCommentInput';
import { isPostDeleted } from '@src/model/upvote/helpers';
import CommentsSection from '@src/pages/TokenPage/PostTab/CommentsSection';
import { type FC, Fragment, memo } from 'react';
import PostStatsAndReactions from '../PostStatsAndReactions/PostStatsAndReactions';

interface PostViewFooterProps {
    postId: string;
    tokenName: string;
    highlightCommentId?: string;
}

const PostViewFooter: FC<PostViewFooterProps> = props => {
    const { postId, tokenName, highlightCommentId } = props;
    return (
        <Fragment>
            <CommentsSection highlightCommentId={highlightCommentId} tokenName={tokenName} postId={postId} />
            {/* <div className="px-4 pb-4 space-y-2">
                <QuickCommentInput postId={postId} tokenName={tokenName} />
                <PostStatsAndReactions className="h-5 space-x-4 text-gray-500 lg:space-x-5" tokenName={tokenName} isDisabled={isPostDeleted(postId)} postId={postId} />
            </div> */}
        </Fragment>
    );
};

export default memo(PostViewFooter);
